import { User } from '@hakimo-ui/hakimo/types';
import {
  DescriptionList,
  DescriptionListItem,
} from '@hakimo-ui/hakimo/ui-elements';
import { useAuthUtils } from '@hakimo-ui/hakimo/util';
import ProfileSection from '../profile-section/ProfileSection';
import ResetPassword from './ResetPassword';

export interface Props {
  user: User;
  /**
   * The admin app turns this off: after the new password is set, Auth0 sends
   * people to the portal's login page, not back to the admin app.
   */
  showPasswordReset?: boolean;
}

export function General(props: Props) {
  const { user, showPasswordReset = true } = props;
  const { canResetPassword } = useAuthUtils();

  const listItems: DescriptionListItem[] = [
    {
      name: 'Name',
      value: user.name ?? '-',
    },
    {
      name: 'Email',
      value: user.email,
    },
    {
      name: 'Roles',
      value: user.roles.join(', '),
    },
    {
      name: 'Tenant',
      value: user.tenant.name,
    },
    // Only users whose password Auth0 holds get this; SSO users manage their
    // password with their company and see no row.
    ...(showPasswordReset && canResetPassword
      ? [
          {
            name: 'Password',
            value: <ResetPassword email={user.email} />,
            infoText: "We'll email you a link to set a new password.",
          },
        ]
      : []),
  ];

  const account = <DescriptionList items={listItems} />;

  return (
    <div className="mx-auto w-full max-w-2xl">
      <ProfileSection title="Account" content={account} />
    </div>
  );
}

export default General;
